<template>
    <b-modal id="modal-certidao-detalhe" size="xl" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" ref="modalCertidaoDetalhe">
       <template v-slot:modal-header="{ close }">
            <h5 v-if="!(loading || error)">Pedido de Certidão nº {{ nrPedido }}</h5>
        </template>
        <template v-slot:default="{ hide }">
            <template v-if="loading || error">
                <div v-if="loading" class="text-center"
                    style="
                        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
                        width: 100%;
                        height: 100%;
                        display: block;
                        z-index: 10002;
                        margin: 0;
                    "
                >
                    <b-spinner
                        variant="primary"
                        style="width: 3rem; height: 3rem"
                        label="Text Centered"
                    ></b-spinner>
                    <br /><span style="color: #004e86">Processando Aguarde...</span>
                </div>
            </template>
            <template v-else>
                <b-row>
                    <b-col class="col-xl-6 col-12 card-column-left">
                        <div class="modal-card pt-2">
                            <div class="modal-card-header">
                                <h3>Dados do Solicitante</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nome:</b> {{ solicitante.nm_solicitante }}</span>
                                <span><b>Documento:</b> {{ solicitante.documento_solicitante }}</span>
                                <!-- TODO - ADICIONAR CAMPOS ESTADOCIVIL E PROFISSAO NA CHAMADA -->
                                <!-- <span><b>Estado Civil:</b> {{ solicitante.estadoCivil }}</span> -->
                                <!-- <span><b>Profissão:</b> {{ solicitante.profissao }}</span> -->
                                <span><b>Telefone:</b> {{ solicitante.telefone_solicitante }}</span>
                                <span><b>Celular:</b> {{ solicitante.celular_solicitante }}</span>
                                <span><b>E-mail:</b> {{ solicitante.nm_email_solicitante }}</span>
                                <hr />
                                <span><b>Endereço:</b> 
                                    {{ solicitante.endereco_solicitante + ', ' + solicitante.nr_endereco_solicitante + (solicitante.complemento_solicitante ? ' - ' + solicitante.complemento_solicitante : '') +
                                                                    ' - ' + solicitante.bairro_solicitante + ' - ' +
                                                                    solicitante.cidade_solicitante + ' - ' + solicitante.uf_solicitante }}</span>
                            </div>
                        </div>
                        <div class="modal-card pt-2">
                            <div class="modal-card-header">
                                <h3>Dados do Cartório</h3>
                            </div>
                            <div class="modal-card-body">                           
                                <span><b>Nome:</b> {{ cartorio.nome_cartorio }}</span>
                                <span><b>E-mail:</b> {{ cartorio.email_cartorio }}</span>
                                <span><b>CNPJ:</b> {{ cartorio.documento_cartorio }}</span>
                                <span><b>Telefone:</b> {{ cartorio.telefone_cartorio }}</span>
                                <hr>
                                <span><b>Endereço:</b> {{ cartorio.endereco_cartorio + ', ' + cartorio.nr_endereco_cartorio + 
                                                                        ( cartorio.complemento_cartorio ? ' - ' + cartorio.complemento_cartorio : '' ) }}</span>
                                <span><b>Bairro:</b> {{ cartorio.bairro_cartorio }}</span>
                                <span><b>Cidade:</b> {{ cartorio.cidade_cartorio }}</span>
                                <span><b>UF:</b> {{ cartorio.uf_cartorio }}</span>
                                <span><b>CEP:</b> {{ cartorio.cep_cartorio }}</span>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="col-12 card-column-right">
                        <div class="modal-card pt-2">
                            <div class="modal-card-header">
                                <h3>Dados do Pedido</h3>
                            </div>
                            <div class="modal-card-body">                           
                                <span><b>Nº Pedido:</b> {{ pedido.cd_pedido }}</span>
                                <span><b>Dt. Pedido:</b> {{ pedido.data_pedido }}</span>
                                <span><b>Status:</b> {{ pedido.status_pedido }}</span>
                                <span v-if="pedido.cd_status == 1" ><b>Valor Cotação:</b> {{ pedido.vl_orcamento }}</span>
                                <span v-if="pedido.cd_status == 17" ><b>Valor Complementar:</b> {{ pedido.vl_orcamento }}</span>
                                <!-- <span><b>Valor Pedido:</b> {{ pedido.vl_orcamento }}</span> -->
                                <span><b>Chave Verificação:</b> {{ pedido.nm_chave_verificacao }}</span>
                                <span v-if="pedido.cd_status == 17" ><b>Valor Cotação: </b>{{certidao.valor_cotacao_original}}</span>
                                <!-- TODO - ALERT COM MENSAGENS AO USUARIO (QUAIS MENSAGENS MOSTRAR?) -->
                                <template v-if="hasArquivosCertidao">
                                    <div class="arquivo-certidao" v-for="arquivo in arquivosCertidao">
                                        <span>
                                            <b>Certidão :</b> {{arquivo.nm_original}} <br>
                                            <b>Enviado em:</b> {{ arquivo.data_cadastro}}
                                        </span>
                                        <b-button class="download-ted" variant="info" @click="downloadArquivoPdf(arquivo)" style="cursor:pointer"><font-awesome-icon size="1x" icon="download"/> Baixar</b-button>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="modal-card pt-2 pb-3">
                            <div class="modal-card-header">
                                <h3>Dados da Certidão</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nome Pesquisado:</b> {{ certidao.nm_pesquisado }}</span>
                                <span><b>Doc. Pesquisado:</b> {{ certidao.documento_pedido }}</span>
                                <span><b>RG Pesquisado:</b> {{ certidao.rg_pedido }}</span>
                                <span><b>CEP:</b> {{ certidao.nr_cep_pesquisado }}</span>
                                <span><b>Endereço:</b> {{ certidao.nm_endereco_pesquisado }}</span>
                                <span><b>Bairro:</b> {{ certidao.nm_bairro_pesquisado }}</span>
                                <span><b>Cidade:</b> {{ certidao.nm_cidade_pesquisado }}</span>
                                <span><b>UF:</b> {{ certidao.nm_uf_pesquisado }}</span>
                                <span><b>E-mail:</b> {{ certidao.nm_email_pesquisado }}</span>
                                <span><b>Motivo da Solicitação:</b> {{ certidao.motivo_pedido }}</span>
                                <span><!--FILLERSPAN--></span>
                                <span class="mt-4 mb-3"><i>Certidão relativa aos últimos 5 anos.</i></span>
                            </div>
                        </div>
                        <!-- <div class="modal-card pt-2" v-if="hasHistoricoTed">
                            <div class="modal-card-header">
                                <h3>Histórico da TED</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nº Pagamento:</b> {{ historicoTed.nr_pagamento }}</span>
                                <span><b>Vlr. Pagamento:</b> {{ historicoTed.vl_ted }}</span>
                                <div class="row-body">
                                    <span><b>Status</b></span>
                                    <span><b>Ocorrência</b></span>
                                    <span><b>Data</b></span>
                                </div>
                                <div class="row-body" v-for="(historico, index) in historicoTed.historicos">
                                    <span> {{ historico.statusTed }}</span>
                                    <span> {{ historico.nm_descricao + ' - ' + historico.ds_erro }}</span>
                                    <span> {{ historico.dt_cadastro}}</span>
                                </div>
                                <b-button v-if="historicoTed.ic_download_comprovante" class="download-ted" variant="info" @click="downloadComprovanteTed(pedido.cd_certidao)"><font-awesome-icon size="1x" icon="download"/> Comprovante TED</b-button>
                            </div>
                        </div> -->
                        <div class="modal-card pt-2" v-if="hasHistoricoBoleto">
                            <div class="modal-card-header">
                                <h3>Histórico do Recebimento</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nº Pedido:</b> {{ historicoBoleto.codigoPedido }}</span>
                                <span><b>Vlr. Recebimento:</b> {{ historicoBoleto.valorBoleto }}</span>
                                <span><b>Forma Pgto.:</b> {{ historicoBoleto.formaPagamento }}</span>
                                <span></span>
                                <span class="d-none d-xl-block"><b>Status</b></span>
                                <span class="d-none d-xl-block"><b>Data</b></span>
                                <template v-for="(historico, index) in historicoBoleto.historicos">
                                    <span class="d-block d-xl-none"><b>Status</b> {{ (1+index) + ' - ' + historico.nm_boleto_status }}</span>
                                    <span class="d-none d-xl-block">{{ (1+index) + ' - ' + historico.nm_boleto_status }}</span>
                                    <span class="d-block d-xl-none"><b>Data</b> {{ historico.dt_cadastro }}</span>
                                    <span class="d-none d-xl-block">{{ historico.dt_cadastro }}</span>
                                </template>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </template>
        </template>
        <template v-slot:modal-footer="{ ok }">
            <b-button :disabled="loading" size="lg" variant="success" @click="devolveResposta('s')" >Fechar</b-button>
        </template>
    </b-modal>
</template>
<script>

import API from '../../services/api';
export default {
    props:{
        nrPedidoCertidao : '',
        certidaoDados:{},
    },
    methods: {
        getCertidaoDetalhe(){
            this.loading = true;
            // this.error = false;
            this.token = localStorage.getItem('jwtToken');
            this.carregando = true;
            this.getHistoricoTed();
            this.getHistoricoBoleto();
            this.getArquivosCertidao();
            this.loading = false;
            this.carregando = false;
        },
        getArquivosCertidao(){
            if(this.certidaoDados.cd_certidao){
                API.get(`certidao/detalhe/arquivos/${this.certidaoDados.cd_certidao}?token=${this.token}`).then((res) => {
                    this.modalCertidaoOk = true;
                    this.arquivosCertidaoDados = res.data;
                    if(this.arquivosCertidaoDados && this.arquivosCertidaoDados !== undefined && Object.keys(this.arquivosCertidaoDados).length > 0  && this.arquivosCertidaoDados.length > 0){
                        let arquivosLista = this.arquivosCertidaoDados;
                        let arquivos = [];
                        arquivosLista.forEach(arquivo => {
                            arquivos.push({
                                id: arquivo.id,
                                nm_original: arquivo.nm_original,
                                data_cadastro: this.formatDataHora(arquivo.data_cadastro),
                                status: arquivo.status,
                                file: arquivo.file,
                            });
                        });     
                        this.hasArquivosCertidao = true;
                        this.arquivosCertidao = arquivos;
                    }
                    else{
                        this.hasArquivosCertidao = false;
                        this.arquivosCertidao = [];
                    }
                }).catch((error) => {
                    this.hasArquivosCertidao = false;
                    console.log(error);
                });
            }
        },
        getHistoricoTed(){
            if(this.certidaoDados.cd_ted_arquivo){
                API.get(`certidao/historico/ted/${this.certidaoDados.cd_ted_arquivo}?token=${this.token}`).then((res) => {
                    this.modalCertidaoOk = true;
                    this.historicoTedDados = res.data;
                    if(this.historicoTedDados && this.historicoTedDados !== undefined && Object.keys(this.historicoTedDados).length > 0  && this.historicoTedDados.length > 0){
                        let tedLista = this.historicoTedDados;
                        let historicoTed = {
                            vl_ted: this.currencyFormatter.format(tedLista[0].vl_ted?tedLista[0].vl_ted:''),
                            nr_pagamento: tedLista[0].nr_pagamento,
                            historicos:[],
                            ic_download_comprovante: (this.certidaoDados.cd_ted_status == 2),
                        };
                        tedLista.forEach(ted => {
                            historicoTed.historicos.push({
                                cd_ted_arquivo_status: ted.cd_ted_arquivo_status,
                                dt_cadastro: this.formatDataHora(ted.dt_cadastro),
                                nm_descricao: ted.nm_descricao,
                                ds_erro: ted.ds_erro,
                                nm_ted_status: ted.nm_ted_status,
                                statusTed: this.getStatusHistoricoTed(ted.ds_erro, ted.cd_ted_arquivo_status, ted.nm_ted_status),
                            });
                        });     
                        this.hasHistoricoTed = true;
                        this.historicoTed = historicoTed;
                    }
                    else{
                        this.hasHistoricoTed = false;
                        this.historicoTed = {};
                    }
                }).catch((error) => {
                    this.hasHistoricoTed = false;
                    console.log(error);
                });
            }
        },
        getHistoricoBoleto(){
            if(this.certidaoDados.cd_pedido){
                API.get(`certidao/historico/boleto/${this.certidaoDados.cd_certidao}?token=${this.token}`).then((res) => {
                    this.modalCertidaoOk = true;
                    this.historicoBoletoDados = res.data;
                    if(this.historicoBoletoDados && this.historicoBoletoDados !== undefined && Object.keys(this.historicoBoletoDados).length > 0  && this.historicoBoletoDados.length > 0){
                        let boletos = this.historicoBoletoDados;
                        let historicoBoleto = {
                            codigoPedido: boletos[0].cd_pedido,
                            valorBoleto: this.currencyFormatter.format(boletos[0].vl_boleto?boletos[0].vl_boleto:''),
                            formaPagamento: this.getFormaPagtoLiquidacao(boletos[0].cd_pedido?boletos[0].cd_pedido:''),
                            historicos:[],
                        };
                        boletos.forEach(boleto => {
                            historicoBoleto.historicos.push({
                                cd_boleto_status: boleto.cd_boleto_status,
                                vl_boleto: this.currencyFormatter.format(boleto.vl_boleto),
                                cd_pedido: boleto.cd_pedido,
                                nm_boleto_status: boleto.nm_boleto_status,
                                cd_boleto: boleto.cd_boleto,
                                cd_api_boleto_config: boleto.cd_api_boleto_config,
                                dt_cadastro: this.formatDataHora(boleto.dt_cadastro),
                            });
                        });                
                        this.hasHistoricoBoleto = true;
                        this.historicoBoleto = historicoBoleto;
                    }
                    else{
                        this.hasHistoricoBoleto = false;
                        this.historicoBoleto = [];
                    }
                }).catch((error) => {
                    this.hasHistoricoBoleto = false;
                    console.log(error);
                });
            }
        },
        devolveResposta(resposta) {
            this.loading = true;
            this.cleanModal();
            this.$emit('resposta',{respostaFinal: resposta});
            this.$bvModal.hide('modal-certidao-detalhe');
        },
        cleanModal(){
            this.nrPedidoCertidao = null;
            this.certidaoDados = {};
            this.historicoTedDados = {};
            this.historicoBoletoDados = [];
            this.hasHistoricoBoleto = false;
            this.hasHistoricoTed = false;
        },
        // #region funções auxiliares para montar a apresentação de valores
        getFormaPagtoLiquidacao(string) {
            switch (string.substr(0, 3)) {
                case 'EPB': return 'Boleto'
                case 'EPP': return 'PIX'
                case 'EPC': return 'Cartão'
                default: return 'Boleto'
            }
        },
        getStatusHistoricoTed(ds_erro, cd_ted_arquivo_status, nm_ted_status) {
            switch (ds_erro) {
                case 'HA':
                    return 'Em processamento';
                case 'BW':
                    return '2 - Processado';
                default:
                    return cd_ted_arquivo_status + ' - ' + nm_ted_status;
            }
        },
        formatDataHoraToData(string){
            let dt_hora = string ? string.split(' ')[0].split('-').reverse().join('/') : '';
            dt_hora = dt_hora != '' ? [dt_hora, string.split(' ')[1]].join(' ') : '';
            return dt_hora.split(' ')[0];
        },
        formatDataHora(string){
            let dt_hora = string ? string.split(' ')[0].split('-').reverse().join('/') : '';
            dt_hora = dt_hora != '' ? [dt_hora, string.split(' ')[1]].join(' ') : '';
            return dt_hora;
        },
        formatData(string){
            return string ? string.split('-').reverse().join('/') : '';
        },
        formatDocumento(string) {
            if (string == null) {
                return '';
            } else {
                let v = string;
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    v = v.replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2")
                            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                            .replace(/\.(\d{3})(\d)/, ".$1/$2")
                            .replace(/(\d{4})(\d)/, "$1-$2");
                }
                return v;
            }
        },
        formatCep(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{3})\d+?$/, '$1');
        },
        formatPhone(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{2})(\d)/, '($1) $2')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{4})\d+?$/, '$1');
        },
        formatRg(string){
            if (string == null) return '';
            else return string.replace(/\D/g,"")
                            .replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/,"$1.$2.$3-$4");
        },
        // #endregion
        // #region downloads -- detalhe do pedido
        //#endregion
        downloadComprovanteTed: function (cd_certidao){
            const token = localStorage.getItem("jwtToken");
            var self = this;
            this.carregando = true;
            API.post(
                "/protesto/comprovanteTed",
                {
                    cd_pedido_cartorio: cd_certidao,
                    cd_certidao:        cd_certidao,
                    token: token
                },
                { responseType: "arraybuffer", }
            ).then(  
                function (res) {
                    let blob = new Blob([res.data], {
                        type: "application/pdf",
                    });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "comprovante.pdf";
                    link.click();
                    this.carregando = false;
                },
                function (err) {
                    this.carregando = false;
                    alert("Erro ao gerar recibo");
                    console.log(err);
                }
            );
        },
        downloadArquivoPdf(arquivo) {
            console.log(arquivo);
            this.carregando = true
            let link = document.createElement('a')
            link.href = arquivo.file
            link.download = arquivo.nm_original
            link.click();
            this.carregando = false;
        },
    },
    data(){
        return{
            loading:false,
            error:false,
            resposta: 's',
            currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),
            historicoTedDados:{},
            historicoBoletoDados:[],
            arquivosCertidaoDados:[],
            hasArquivosCertidao:false,
            hasHistoricoTed:false,
            hasHistoricoBoleto:false,
            modalCertidaoOk:false,
            statusGerarLote: [1, 13, 15],
            carregando: false,
            token:'',
            historicoTed:{},
            historicoBoleto:[],
            arquivosCertidao:[],
        }
    },
    computed:{
        nrPedido(){
            if(this.nrPedidoCertidao !== undefined && this.nrPedidoCertidao !== null) return this.nrPedidoCertidao.toLocaleString();
            else return '';
        },
        pedido(){
            if(this.certidaoDados !== undefined && this.certidaoDados !== null){
                let pedidoDados     = this.certidaoDados;                
                let pedido          = {
                    data_pedido: this.formatDataHoraToData(pedidoDados.data_pedido),
                    vl_orcamento: pedidoDados.vl_orcamento ? this.currencyFormatter.format(pedidoDados.vl_orcamento) : '',
                    cd_pedido: pedidoDados.cd_pedido,
                    cd_certidao: pedidoDados.cd_certidao,
                    status_pedido: pedidoDados.status_pedido,
                    nm_chave_verificacao: pedidoDados.nm_chave_verificacao,
                };
                return pedido;
            }
            else return {}
        },
        certidao(){
            if(this.certidaoDados !== undefined && this.certidaoDados !== null){
                let pedidoCertidaoDados     = this.certidaoDados;                
                let certidao                = {
                    documento_pedido: this.formatDocumento(pedidoCertidaoDados.documento_pedido),
                    rg_pedido: this.formatRg(pedidoCertidaoDados.rg_pedido),
                    nr_cep_pesquisado: this.formatCep(pedidoCertidaoDados.nr_cep_pesquisado),
                    nm_pesquisado: pedidoCertidaoDados.nm_pesquisado,
                    nm_endereco_pesquisado: pedidoCertidaoDados.nm_endereco_pesquisado,
                    nm_bairro_pesquisado: pedidoCertidaoDados.nm_bairro_pesquisado,
                    nm_cidade_pesquisado: pedidoCertidaoDados.nm_cidade_pesquisado,
                    nm_uf_pesquisado: pedidoCertidaoDados.nm_uf_pesquisado,
                    nm_email_pesquisado: pedidoCertidaoDados.nm_email_pesquisado,
                    motivo_pedido: pedidoCertidaoDados.motivo_pedido,
                };
                return certidao;
            }
            else return {}
        },
        cartorio(){
            if(this.certidaoDados !== undefined && this.certidaoDados !== null){
                let cartorioDados   = this.certidaoDados;                
                let cartorio        = {
                    documento_cartorio: this.formatDocumento(cartorioDados.documento_cartorio),
                    cep_cartorio: this.formatCep(cartorioDados.cep_cartorio),
                    telefone_cartorio: this.formatPhone(cartorioDados.telefone_cartorio),
                    nome_cartorio: cartorioDados.nome_cartorio,
                    email_cartorio: cartorioDados.email_cartorio,
                    endereco_cartorio: cartorioDados.endereco_cartorio,
                    nr_endereco_cartorio: cartorioDados.nr_endereco_cartorio,
                    complemento_cartorio: cartorioDados.complemento_cartorio,
                    bairro_cartorio: cartorioDados.bairro_cartorio,
                    cidade_cartorio: cartorioDados.cidade_cartorio,
                    uf_cartorio: cartorioDados.uf_cartorio,
                };
                return cartorio;
            }
            else return {}
        },
        solicitante(){
            if(this.certidaoDados !== undefined && this.certidaoDados !== null){
                let solicitanteDados    = this.certidaoDados;                
                let solicitante         = {
                    documento_solicitante: this.formatDocumento(solicitanteDados.documento_solicitante),
                    telefone_solicitante: this.formatPhone(solicitanteDados.telefone_solicitante),
                    celular_solicitante: this.formatPhone(solicitanteDados.celular_solicitante),
                    nm_solicitante: solicitanteDados.nm_solicitante,
                    nm_email_solicitante: solicitanteDados.nm_email_solicitante,
                    endereco_solicitante: solicitanteDados.endereco_solicitante,
                    nr_endereco_solicitante: solicitanteDados.nr_endereco_solicitante,
                    complemento_solicitante: solicitanteDados.complemento_solicitante,
                    bairro_solicitante: solicitanteDados.bairro_solicitante,
                    cidade_solicitante: solicitanteDados.cidade_solicitante,
                    uf_solicitante: solicitanteDados.uf_solicitante,
                };
                return solicitante;
            }
            else return {}
        },
    },
    mounted(){
    },
    watch:{
        nrPedidoCertidao(val){
            if(val !== undefined && val !== '' && val !== null)
                this.modalCertidaoOk = true;
            else
                this.modalCertidaoOk = false;
        },
        modalCertidaoOk(val){
            if(val){
                this.getCertidaoDetalhe();
            }
        },
    }
}
</script>
<style scoped>

.modal-card{
    display: flex;
    flex-flow: column;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    margin-bottom: 30px;
    padding: 0 10px;
}
.modal-card-header{
    border-bottom: 1px solid rgba(0,0,0,.125);
    padding: .75rem 1.25rem;
}

h5 {
    font: normal normal 200 25px/25px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    margin: 0px;
}
h3 {
    font: normal normal 200 20px/18px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    color:var(--secondary-color) !important;
    margin: 0px;
}
span{
    margin-bottom: 18px;
    font: normal normal 200 16px/17px 'Kanit', sans-serif;
    letter-spacing: -1%;
}
.modal-card-body{
    padding: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}
.card-column-left{max-width: 370px;}
.card-column-left .modal-card-body{gap: 0;}
.card-column-right{max-width: calc(100% - 370px)}
.card-column-left .modal-card-body span{
    flex: 1 1 100%;
    max-width: 100%;
}
.card-column-right .modal-card-body .row-body{
    flex: 1 1 95%;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}
.card-column-right .modal-card-body .row-body span{
    flex: 1 1 32%;
    max-width: 32%;
}
.card-column-right .modal-card-body > span{
    flex: 1 1 49%;
    max-width: 49%;
}
.btn.btn-success{
    width: 160px;
    height: 44px;
    background: #1ACEB5 0% 0% no-repeat padding-box;
    font: normal normal bold 15px/15px 'Kanit', sans-serif;
    border-radius: 5px;
    opacity: 1;
    border: none;
    outline: none;
}
.btn.btn-success:disabled{
    background:#1aceb55c 0% 0% no-repeat padding-box
}
.btn.btn-success:active,
.btn.btn-success:focus{
    background: #1ACEB5 0% 0% no-repeat padding-box;
    box-shadow: none;
    border: none;
    outline: none;
}
hr{width: 100%;margin-bottom: 1rem;}

.btn.download-ted {
    min-width: 195px;
    margin-left: auto;
}
.btn.download-ted > * {    
    color: white !important;
}
.arquivo-certidao{
    margin-bottom: 10px;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 10px;
    border: 1px solid rgba(0,0,0,.125);
}
.arquivo-certidao span{
    width: calc(100% - 195px - 20px);
    margin-bottom: 0px;
}


@media (max-width:1199px) {
    
    .card-column-left{max-width: unset;}
    .card-column-right{max-width: unset;}
    .card-column-right .modal-card-body > span{flex: 1 1 100%;max-width: 100%;}
    .card-column-right .modal-card-body .row-body span{flex: 1 1 100%;max-width: 100%;}
    .btn.download-ted{width: 100%;}
}
</style>